// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DegreePlusOffice_wrapper__Ll67h","arrow":"DegreePlusOffice_arrow__p7OTn","arrowDown":"DegreePlusOffice_arrowDown__F_fOm","icon":"DegreePlusOffice_icon__ypNze"};